export default __webpack_public_path__ + "static/media/YAS0270.34I-27743_-17214_0.91c8e84a.jpg";